import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { installAuthFetch } from "@/utils/authClient";

// Send credentials (httpOnly auth cookie) with every backend fetch.
installAuthFetch();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
